<template>
  <div class="container">
    <Header :home="true"></Header>
    <div class="container-box">
      <div>
        <keep-alive :include='includes'>
        <router-view />
        </keep-alive>
      </div>
      <div v-if="$route.path!='/subscribe' && $route.path!='/payment' && $route.path!='/checkout'" :style="$route.path=='/home'&&$store.getters.currentWidth>768?'position:absolute;bottom: 0;left:0;right:0;':''">
        <Footer></Footer>
      </div>
      <!-- <div class="external-link">
          <img class="cursor-pointer" @click="onWhatsapp" src="@/assets/images/whapp.png"/>
          <img class="cursor-pointer" @click="onFacebook" src="@/assets/images/fool.png"/>
      </div> -->
      <div class="scroll-to cursor-pointer">
          <img @click="onScrollTo"  src="@/assets/images/GoToTop_Btn.png">
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
import { scrollTo } from '@/utils/scroll-to'
export default {
  components: { Header , Footer },
  data() {
    return {
      whatsapp:'https://chat.whatsapp.com/SomeLettersandsomeNUMBERS',
      facebook:'https://www.facebook.com',
      includes: 'home'
    }
  },
  methods:{
    onScrollTo(){
        scrollTo(0, 800)
    },
    onWhatsapp(){
      window.open(this.whatsapp, "_blank");
    },
    onFacebook(){
      window.open(this.facebook, "_blank");
    },
  }
};
</script>
<style lang="scss"  scoped>
.container {
  min-height: 100% !important;
  //background-color: #d3f7ff;
  display: flex;
  flex-direction: column;
}

.container-box {
  position:relative;
  /*background-image: url("~@/assets/images/container-top.png");
  background-repeat: no-repeat;
  background-size: 100%;*/
  // overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.scroll-to{
  position:fixed;
  right: 0;
  top:50%;
  width: 3.625rem;
}
/*.cursor-pointer{
  width: 2.375rem;
  height: 2.375rem;
}*/
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .container{
    overflow: auto;
  }
  .cursor-pointer{
    margin: 0.5rem 0;
  }
}
</style>